import axios from "axios";

/**
 * @param {Object} data - The data to be sent in the request body.
    * @param {string} data.summary - The title of the event.
    * @param {string} data.description - The description of the event.
    * @param {string} data.startDateTime - The start time of the event in ISO format.
    * @param {string} data.endDateTime - The end time of the event in ISO
    * @param {string[]} data.attendees- The  list of email address of the peoples.
    * @param {string} data.timezone - The timezone of the event.
    * @param {boolean} data.sendNotification - Whether to send notifications to attendees.
    * @param {string} data.location - The location of the event.
 * **/
 const ValidateData = data => {
  if (!data) throw new Error("Data object is required");

  const {
    summary,
    startDateTime,
    endDateTime,
    location,
    attendees
  } = data;

  if (!summary || typeof summary !== 'string') {
    throw new Error("Missing or invalid 'summary'");
  }

 
  if (!startDateTime || isNaN(Date.parse(startDateTime))) {
    throw new Error("Missing or invalid 'startTime'");
  }

  if (!endDateTime || isNaN(Date.parse(endDateTime))) {
    throw new Error("Missing or invalid 'endTime'");
  }

  if (new Date(startDateTime) >= new Date(endDateTime)) {
    throw new Error("'endTime' must be after 'startTime'");
  }

  if (!Array.isArray(attendees) || !attendees.every(email => typeof email === 'string')) {
    throw new Error("Invalid 'attendees' (must be an array of strings)");
  }

 
};

export const meetAndMail = async (data) => {
    try {
        ValidateData(data);
        
        const response = await axios.post(`${process.env.REACT_APP_MEET_AND_MAIL}/mail_and_meet_service`,
            data,{
                headers: {
                    'Content-Type': 'application/json',
            }}

        )
        return response.data;
    } catch (error) {
        console.error("Error in meetAndMail:", error);
        throw new Error("Failed to process meet and mail request");
        
    }
}
